import React, { useCallback, useEffect, useState } from "react";
import "./index.less";

import { message, Checkbox, Modal, Button } from "antd";
import IconFont from "@/components/icon";
import { CheckboxChangeEvent } from "antd/es/checkbox/Checkbox";
import Bus from "@/utils/bus";
import { ChatMessage, Session } from "@/types/chat";
import { CheckInviteeResult } from "../../GroupUserSelector/common";

interface IProps {
  selectedSession: Session;
  messages: ChatMessage[];
  searchMessages?: Function;
}

function MemberCustomAreaExtra(props: IProps) {
  const { searchMessages } = props;
  const [recordsNum, setRecordsNum] = useState(0);
  const [records, setRecords] = useState<ChatMessage[]>([]);
  const [recordsChecked, setRecordsChecked] = useState(false);

  const handleAddMembersConfirm = useCallback(
    (type: CheckInviteeResult) => {
      console.log(type, recordsChecked);
      if (type !== CheckInviteeResult.Normal && recordsChecked) {
        return message.info("不支持分享聊天记录");
      }
    },
    [recordsChecked]
  );

  // useEffect(() => {
  //   const selectedMessages = messages.splice(0, 20);
  //   if (selectedMessages.length) {
  //     setRecordsNum(selectedMessages.length);
  //     setRecords(selectedMessages);
  //     Bus.emit("chatting-records-commit", selectedMessages);
  //     Bus.emit("chatting-records-checkbox-change", true);
  //   }
  // }, [messages]);

  const handleRecordsNumChange = useCallback((messages: ChatMessage[], init?: boolean) => {
    console.log("handleRecordsNumChange=>", messages, init);
    Bus.emit("chatting-records-commit", messages);
    setRecordsChecked(init ? false : !!messages.length);
    Bus.emit("chatting-records-checkbox-change", init ? false : !!messages.length);
    setRecordsNum(messages.length);
    setRecords(messages);
  }, []);

  useEffect(() => {
    Bus.on("selectChattingRecordsConfirm", handleRecordsNumChange);
    if (searchMessages) {
      searchMessages().then((res: any) => {
        console.log("useeffect=>", res);
        handleRecordsNumChange(res || [], true);
      });
    }
    console.log("selectChattingRecordsConfirm-on");
    return () => {
      Bus.off("selectChattingRecordsConfirm", handleRecordsNumChange);
      console.log("selectChattingRecordsConfirm-off");
    };
  }, [handleRecordsNumChange, searchMessages]);

  const handleCustomClick = useCallback(() => {
    // setRecordsNum(20);
    Bus.emit("chatting-records-modal-show", { records: [...records], canChecked: true });
  }, [records]);

  const handleRecordsCheckedChange = (e: CheckboxChangeEvent) => {
    // onRecordsCheckedChange(e);
    setRecordsChecked(e.target.checked);
    Bus.emit("chatting-records-checkbox-change", e.target.checked);
  };

  return (
    <div className="group-members-extra">
      <Checkbox checked={recordsChecked} onChange={handleRecordsCheckedChange} />
      <span onClick={handleCustomClick} className="extra-content">
        分享沟通记录（<span className="records-num">已选{recordsNum}条</span>）
        <IconFont className="right-icon" type="iconwin_right" />
      </span>
    </div>
  );
}

export default MemberCustomAreaExtra;
